import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import GlobalSearchResults from '../../dtos/GlobalSearchResults';
import { GlobalSearchService } from '../../services/global-search.service';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.sass']
})
export class GlobalSearchComponent implements OnInit {
  globalSearchQueryValue: string;
  options: GlobalSearchResults = new GlobalSearchResults();
  currentTimeout: any;
  globalSearchSearchValue: string;
  private isNavigating: boolean = false;

  constructor(
    private globalSearchService: GlobalSearchService,
    private router: Router,
    private messageService: MessageService,
    public authService: AuthService,
  ) { }

  /**
   * Global Search Component Initialization
   */
  async ngOnInit() {
    this.options.GroupedEntities = [];
  }

  /**
   * Perform a search query on multiple entities.
   * 
   * @param event The search query value
   */
  async globalSearch(event: any) {
    this.globalSearchSearchValue = event.query;

    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
    }

    this.currentTimeout = setTimeout(async () => {
      try {
        let response = await this.globalSearchService.globalSearch(event.query);
        if (response && response.GroupedEntities) {
          this.options.GroupedEntities = response.GroupedEntities;
        }
      } catch (error: any) {
        const errorMessage = error.status === 403 ? (error.error?.error || error.statusText) : 'An error occurred Searching.';
        this.messageService.add({
          severity: 'error',
          summary: 'Error Searching',
          detail: errorMessage,
        });
      }
      this.currentTimeout = null;
    }, 500);
  }

  /**
   * Handle Selected option from dropdown
   * 
   * @param selectedValue Selected entity
   * @param event Optional event to prevent default behavior
   */
  onSelectedEntity(selectedValue: any, event?: Event) {
    // Prevent double execution if already navigating
    if (this.isNavigating) {
      return;
    }
    
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    if (selectedValue && selectedValue.apiControllerRoute && selectedValue.id) {
      this.isNavigating = true;
      
      // Store the route before clearing
      const route = `${selectedValue.apiControllerRoute}/${selectedValue.id}`;
      
      // Navigate immediately while the click event is still active
      // This ensures the browser doesn't block the popup
      const newWindow = window.open(route, "_blank");
      
      // Clear the search input to close the dropdown after navigation
      setTimeout(() => {
        this.globalSearchQueryValue = '';
        this.options.GroupedEntities = [];
        this.isNavigating = false;
      }, 100);
      
      // If popup was blocked, try router navigation as fallback
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        this.router.navigate([route]);
      }
    }
  }

  /**
   * Handle Enter key press.
   * Redirects to advance search page.
   * 
   * @param event Browser event
   */
  onEnterPress(event: any) {
    if (event.key == 'Enter') {
      this.goToAdvanceSearch();
    }
  }

  /**
   * Handle clicks on search button.
   * Redirects to advance search page.
   */
  goToAdvanceSearch() {
    // Redirect to advance search page.
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(
        ['/advanced-search'],
        { queryParams: { searchQuery: this.globalSearchSearchValue } }
      );
    });
  }
}
